import {
  Card,
  CardContent,
  Grid,
  Typography,
  Stack,
  IconButton,
  Box,
  Breadcrumbs,
  Link,
} from "@mui/material";
import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { AppState, useAppDispatch, useAppSelector } from "../../store";
import {
  setIsEditVendor,
  setOpenAddVendorDialog,
  setOpenDeleteVendor,
} from "../../store/slices/vendorSlice";
import DeleteVendorDialog from "./DeleteVendorDialog";
import { codelistUtils } from "../../utils/codelistUtils";

const VendorDetails: React.FunctionComponent<any> = (props) => {
  const {
    getAllVendorsFunc,
    setOpenVendorDetails,
    paginationModel,
    filterVal,
    codelistData,
  } = props;
  const dispatch = useAppDispatch();
  const VendorData = useAppSelector(
    (state: AppState) => state.vendorSlice.vendorDetails
  );
  const openDelete = useAppSelector(
    (state: AppState) => state.vendorSlice.openDeleteVendor
  );

  const onEditClick = async (data: any) => {
    dispatch(setOpenAddVendorDialog(true));
    dispatch(setIsEditVendor(true));
  };
  const onDeleteClick = (data: any) => {
    dispatch(setOpenDeleteVendor(true));
  };

  return (
    <>
      <div role="presentation">
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="primary" onClick={() => setOpenVendorDetails(false)}>
            Vendors
          </Link>
          <Typography color="text.primary">{VendorData?.vendor_id}</Typography>
        </Breadcrumbs>
      </div>
      <Box mt={2}>
        <Card className="pageContent" key={VendorData?.id}>
          <CardContent>
            <Grid container spacing={3} mb={2.5}>
              <Grid item className="maxWidthMinusActionBtns">
                <Typography variant="h6" component="div" className="wordWrap">
                  <Stack direction="row" columnGap={1}>
                    <Box className="wordBreakAll">
                      {VendorData?.vendor_name} &nbsp;
                    </Box>
                  </Stack>
                  <Typography variant="body2" color="text.secondary">
                    {VendorData?.vendor_id}
                  </Typography>
                </Typography>
              </Grid>
              <Grid item>
                <Stack
                  direction="row"
                  spacing={1}
                  className="justifyContentCenter alignItemsCenter"
                >
                  <IconButton
                    color="primary"
                    size="small"
                    title="Edit Vendor"
                    onClick={() => onEditClick(VendorData)}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>

                  <IconButton
                    color="primary"
                    size="small"
                    title="Delete Vendor"
                    onClick={() => onDeleteClick(VendorData)}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Stack>
              </Grid>
            </Grid>

            <Grid container spacing={2} mb={1.5}>
              <Grid item sm={12} md={12}>
                <Typography variant="caption" display="block">
                  Address
                </Typography>
                <Typography variant="body1" gutterBottom>
                  {VendorData?.street_address},{" "}
                  {VendorData?.unit_number && `${VendorData?.unit_number},`}{" "}
                  {VendorData?.city}, {VendorData?.state},{" "}
                  {VendorData?.postal_code},{" "}
                  {codelistData?.length > 0 &&
                    codelistUtils(
                      codelistData,
                      VendorData.country_code,
                      VendorData?.country_value_code
                    )?.selectedValue}
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={2} mb={2}>
              <Grid item sm={12} md={4}>
                <Typography variant="caption">Contact Name</Typography>
                <Typography variant="body1" className="wordWrap">
                  {VendorData?.contact_name}
                </Typography>
              </Grid>
              <Grid item sm={12} md={4}>
                <Typography variant="caption">Contact Email</Typography>
                <Typography variant="body1" className="wordWrap">
                  {VendorData?.contact_email}
                </Typography>
              </Grid>
              <Grid item sm={12} md={4}>
                <Typography variant="caption">Contact Phone Number</Typography>
                <Typography variant="body1">
                  {VendorData?.contact_phone_number}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>

      {openDelete && (
        <DeleteVendorDialog
          getAllVendorsFunc={getAllVendorsFunc}
          paginationModel={paginationModel}
          filterVal={filterVal}
          setOpenVendorDetails={setOpenVendorDetails}
        />
      )}
    </>
  );
};

export default VendorDetails;
